import { dashboardData } from "api/apis";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CountUp from "react-countup";

interface DashboardData {
  totalEarnings: number;
  userCount: number;
  productCount: number;
  orderCount: number;
  invoiceStats: {
    paid: number;
    unpaid: number;
    total: number;
  };
  recentOrders: any[];
}

interface ApiResponse {
  success: boolean;
  data: DashboardData;
}

const Widgets = () => {
  const [dashBoardData, setDashBoardData] = useState<DashboardData | null>(
    null
  );

  const fetchDashBoardData = async () => {
    try {
      const response: ApiResponse = await dashboardData();
      console.log("Dashboard Details: ", response);
      if (response && response.data) {
        setDashBoardData(response.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    fetchDashBoardData();
  }, []);

  // Widget data configuration
  const widgetItems = [
    {
      key: "earnings",
      name: "Total Earnings",
      amount: dashBoardData?.totalEarnings || 0,
      decimal: true,
      perstange: 6.11,
      badgeColor: "success",
      iconColor: "success",
      icon: "ri-coins-line",
    },
    {
      key: "users",
      name: "Users",
      amount: dashBoardData?.userCount || 0,
      decimal: false,
      perstange: 3.58,
      badgeColor: "success",
      iconColor: "info",
      icon: "ri-user-line",
    },
    {
      key: "products",
      name: "Products",
      amount: dashBoardData?.productCount || 0,
      decimal: false,
      perstange: -0.73,
      badgeColor: "danger",
      iconColor: "warning",
      icon: "ri-shopping-bag-line",
    },
    {
      key: "orders",
      name: "Orders",
      amount: dashBoardData?.orderCount || 0,
      decimal: false,
      perstange: 4.07,
      badgeColor: "success",
      iconColor: "primary",
      icon: "ri-file-list-line",
    },
  ];

  return (
    <React.Fragment>
      {(widgetItems || []).map((item: any, key: number) => (
        <Col key={key}>
          <Card className="card-animate">
            <Card.Body>
              <div className="d-flex justify-content-between">
                <div
                  className={"vr rounded bg-" + item.iconColor + " opacity-50"}
                  style={{ width: "4px" }}
                ></div>
                <div className="flex-grow-1 ms-3">
                  <p className="text-uppercase fw-medium text-muted fs-14 text-truncate">
                    {item.name}
                  </p>
                  <h4 className="fs-22 fw-semibold mb-3">
                    {item.decimal ? "₹" : ""}
                    <span className="counter-value" data-target="98851.35">
                      <CountUp
                        start={0}
                        end={item.amount}
                        separator=","
                        decimals={item.decimal && 2}
                      />
                    </span>
                  </h4>
                  <div className="d-flex align-items-center gap-2">
                    <h5
                      className={
                        "mb-0 badge bg-" +
                        item.badgeColor +
                        "-subtle text-" +
                        item.badgeColor
                      }
                    >
                      <i
                        className={
                          item.badgeColor === "success"
                            ? "ri-arrow-right-up-line align-bottom"
                            : "ri-arrow-right-down-line align-bottom"
                        }
                      ></i>{" "}
                      {item.perstange} %
                    </h5>
                    <p className="text-muted mb-0">than last week</p>
                  </div>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span
                    className={
                      "avatar-title bg-" +
                      item.iconColor +
                      "-subtle text-" +
                      item.iconColor +
                      " rounded fs-3"
                    }
                  >
                    <i className={item.icon}></i>
                  </span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </React.Fragment>
  );
};

export default Widgets;
